import { ApiClient } from '@webapp/core/services/ApiClient'
import { PaymentTermRepository } from './PaymentTermRepository'

export const paymentTermRepository = new PaymentTermRepository({
  httpClient: ApiClient,
})

export * from './PaymentTermRepository'
